import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Modal from 'react-modal';
import NavbarBottom from './NavbarBottom';

const DetailProdukHukum = () => {
    const params = useParams();
    const [newsDetail, setNewsDetail] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const StatusDoc = (id) => {
        const statusMap = {
            1: 'Berlaku',
            2: 'Mencabut',
            3: 'Dicabut',
            4: 'Mengubah',
            5: 'Diubah',
        };
        return <span className="font-medium">{statusMap[id] || '-'}</span>;
    };

    const getTipeDokumen = (id) => {
        const tipeMap = {
            1: 'Peraturan Perundangan-undangan',
            2: 'Monografi Hukum',
            3: 'Artikel Hukum',
            4: 'Putusan / Yurisprudensi',
        };
        return tipeMap[id] || '-';
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/documents-detail/${params.id}`)
            .then((res) => res.json())
            .then((datas) => {
                setNewsDetail(datas.data[0]);
            });
    }, [params.id]);

    const renderValue = (value) => (value ? value : '-');

    return (
        <>
            <NavbarBottom />
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    {/* Header Card */}
                    <div className="bg-gradient-to-r from-blue-900 to-indigo-800 rounded-2xl shadow-2xl p-6 md:p-8 text-white mb-8">
                        <p className="text-sm font-light opacity-80 tracking-wide">
                            {renderValue(newsDetail.nama)}
                        </p>
                        <h1 className="text-sm md:text-2xl font-bold mt-2 leading-tight">
                            {renderValue(newsDetail.content)}
                        </h1>
                    </div>

                    {/* Konten Utama */}
                    <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8 space-y-8">
                        {/* Abstrak */}
                        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-blue-50/80 p-5 rounded-xl border border-blue-100 backdrop-blur-sm">
                            <h3 className="font-semibold text-blue-900 text-lg flex items-center gap-3">
                                <span className="text-2xl">📄</span> MATERI POKOK PERATURAN
                            </h3>
                            {newsDetail.file_abstrak ? (
                                <a
                                    href={`${process.env.REACT_APP_BASEURL}/produk_hukum/abstrak/${newsDetail.file_abstrak}`}
                                    className="mt-2 sm:mt-0 inline-flex items-center px-5 py-2.5 bg-blue-900 text-white text-sm font-medium rounded-xl hover:bg-blue-800 transition-all hover:shadow-lg"
                                >
                                    <span className="mr-2">📎</span> Abstrak
                                </a>
                            ) : (
                                <span className="text-gray-400 text-sm">-</span>
                            )}
                        </div>

                        {/* Metadata Peraturan - 2 Kolom */}
                        <div>
                            <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-3 mb-6">
                                <span className="text-2xl">ℹ️</span> METADATA PERATURAN
                            </h3>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                {[
                                    { label: 'Tipe Dokumen', value: getTipeDokumen(newsDetail.tipe_dokumen) },
                                    { label: 'Pemrakarsa', value: newsDetail.pemrakarsa },
                                    { label: 'Jenis', value: newsDetail.nama },
                                    { label: 'Penandatangan', value: newsDetail.penandatangan },
                                    {
                                        label: 'Entitas',
                                        value:
                                            newsDetail.singkatan_jenis === 'PERDA'
                                                ? 'Pemerintah Daerah'
                                                : 'Pemerintah Kota',
                                    },
                                    { label: 'Hasil Uji Materi', value: newsDetail.hasil_uji_materi },
                                    { label: 'Singkatan Jenis', value: newsDetail.singkatan_jenis },
                                    { label: 'T.E.U', value: newsDetail.tajuk_entri_utama },
                                    { label: 'Nomor', value: newsDetail.no_peraturan },
                                    { label: 'Lokasi', value: newsDetail.lokasi },
                                    { label: 'Tahun', value: newsDetail.tahun_diundang },
                                    { label: 'Pengarang', value: newsDetail.pengarang },
                                    { label: 'Judul', value: newsDetail.content },
                                    { label: 'Tempat Penetapan', value: newsDetail.tmp_terbit },
                                    { label: 'Ditetapkan Tanggal', value: newsDetail.tgl_ditetap },
                                    { label: 'Bidang Hukum', value: newsDetail.bidhukumnama },
                                    { label: 'Diundangkan Tanggal', value: newsDetail.tgl_diundang },
                                    { label: 'Subjek', value: newsDetail.file_tags },
                                    { label: 'Sumber', value: newsDetail.sumber },
                                    { label: 'Bahasa', value: newsDetail.language },
                                    { label: 'Diakses', value: newsDetail.view },
                                    { label: 'Diunduh', value: newsDetail.unduh },
                                ].map((item, idx) => (
                                    <div
                                        key={idx}
                                        className="bg-gray-50/80 p-4 rounded-xl border border-gray-100 hover:shadow-md transition-shadow duration-200 flex flex-col"
                                    >
                                        <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                            {item.label}
                                        </p>
                                        <p className="text-sm text-gray-800 font-medium mt-1.5">
                                            {renderValue(item.value)}
                                        </p>
                                    </div>
                                ))}
                                {/* Dua field tambahan untuk kesesuaian jumlah genap */}
                                <div className="bg-gray-50/80 p-4 rounded-xl border border-gray-100 hover:shadow-md transition-shadow duration-200 flex flex-col">
                                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                        Peraturan Terkait
                                    </p>
                                    <p className="text-sm text-gray-800 font-medium mt-1.5">
                                        <Link to={`/detail-produk-hukum/${newsDetail?.pera_terkait}`}>{newsDetail?.judul_pera_terkait}</Link>
                                    </p>
                                </div>
                                <div className="bg-gray-50/80 p-4 rounded-xl border border-gray-100 hover:shadow-md transition-shadow duration-200 flex flex-col">
                                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                        Peraturan Pelaksana
                                    </p>
                                    <p className="text-sm text-gray-800 font-medium mt-1.5">
                                        <Link to={`/detail-produk-hukum/${newsDetail?.pera_pelaksana}`}>{newsDetail?.judul_pera_pelaksana}</Link>
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* File & Status - 2 Kolom Seimbang */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 pt-4">
                            {/* File Peraturan */}
                            <div className="bg-gray-50/80 p-6 rounded-xl border border-gray-200 hover:shadow-md transition-shadow duration-200 flex flex-col h-full">
                                <h3 className="font-semibold text-gray-700 flex items-center gap-2 text-lg">
                                    <span className="text-2xl">📁</span> FILE PERATURAN
                                </h3>
                                <div className="mt-4 flex flex-wrap gap-3 flex-1 items-start">
                                    <a
                                        href={`${process.env.REACT_APP_BASEURL}/${newsDetail.file_url}`}
                                        className="inline-flex items-center px-5 py-2.5 bg-blue-900 text-white text-sm font-medium rounded-xl hover:bg-blue-800 transition-all hover:shadow-lg"
                                    >
                                        ⬇️ Download
                                    </a>
                                    <button
                                        onClick={openModal}
                                        className="inline-flex items-center px-5 py-2.5 bg-orange-700 text-white text-sm font-medium rounded-xl hover:bg-orange-600 transition-all hover:shadow-lg"
                                    >
                                        👁️ Preview
                                    </button>
                                </div>
                            </div>

                            {/* Status Peraturan */}
                            <div className="bg-gray-50/80 p-6 rounded-xl border border-gray-200 hover:shadow-md transition-shadow duration-200 flex flex-col h-full">
                                <h3 className="font-semibold text-gray-700 flex items-center gap-2 text-lg">
                                    <span className="text-2xl">⚖️</span> STATUS PERATURAN
                                </h3>
                                <div className="mt-4 flex flex-col flex-1">
                                    <span className="inline-block px-4 py-2 bg-gray-200 text-gray-800 rounded-xl text-sm font-medium self-start">
                                        {newsDetail?.status_prod
                                            ? StatusDoc(newsDetail.status_prod)
                                            : newsDetail?.status_keterangan_info}
                                    </span>
                                    {newsDetail.judul_terkait && (
                                        <Link
                                            to={`/detail-produk-hukum-terkait/${newsDetail.prod_terkait}`}
                                            className="block mt-3 text-sm text-blue-600 hover:underline font-medium"
                                        >
                                            <em>{newsDetail.judul_terkait}</em>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Preview PDF */}
            <Modal
                isOpen={isModalOpen}
                onRequestClose={closeModal}
                contentLabel="Preview PDF"
                className="modal-content max-w-4xl mx-auto mt-10 bg-white rounded-2xl shadow-2xl overflow-hidden"
                overlayClassName="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 backdrop-blur-sm"
            >
                <div className="h-[85vh] flex flex-col">
                    <div className="flex-1 p-2 bg-gray-100">
                        <object
                            data={`https://docs.google.com/viewerng/viewer?url=${process.env.REACT_APP_BASEURL}/${newsDetail.file_url}&embedded=true`}
                            style={{ width: '100%', height: '100%' }}
                            aria-label="PDF Viewer"
                        >
                            <p className="text-center p-4">
                                Browser Anda tidak mendukung tampilan PDF.{' '}
                                <a
                                    href={`${process.env.REACT_APP_BASEURL}/${newsDetail.file_url}`}
                                    download
                                    className="text-blue-600 underline"
                                >
                                    Unduh file
                                </a>
                            </p>
                        </object>
                    </div>
                    <div className="flex justify-end px-6 py-4 bg-gray-50 border-t border-gray-200">
                        <button
                            onClick={closeModal}
                            className="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-xl transition-colors"
                        >
                            Tutup
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default DetailProdukHukum;